import { useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Lock } from "lucide-react";

export const RequireAuth = ({ children, label = "This part of the calendar is for members" }) => {
  const { user, loading, login } = useAuth();

  if (loading) return <div className="min-h-screen bg-white" />;
  if (user) return children;

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="mx-auto max-w-xl px-4 py-28 text-center">
        <span className="mx-auto grid h-12 w-12 place-items-center rounded-2xl bg-neutral-100">
          <Lock className="h-5 w-5 text-neutral-700" />
        </span>
        <h1 className="mt-6 text-3xl font-extrabold tracking-tight text-neutral-900">Members only</h1>
        <p className="mt-3 text-neutral-600" data-testid="members-only-gate">
          {label}. Sign in with Google to see every date, RSVP and join the conversation.
        </p>
        <button
          onClick={login}
          data-testid="gate-login-btn"
          className="mt-7 rounded-full bg-neutral-900 px-6 py-3 text-sm font-bold text-white transition-colors duration-200 hover:bg-neutral-700"
        >
          Continue with Google
        </button>
      </div>
    </div>
  );
};
